import styled from "styled-components";

const ContainerModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export default ContainerModalContent;
